import { END_POINTS } from "../constants/url";
import emptySplitApi from "../utils/rtk";

interface CommonResponseType {
  status: number;
  message: string;
  statusCode: number;
}

export const GioLoactionApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getLoaction: builder.query<
      CommonResponseType & { data: any },
      {
        search?: string;
        start?: number;
        length?: number;
      }
    >({
      query: ({ length, search, start }) => ({
        url: `${END_POINTS.location}?start=${start}&length=${length}&search=${search}`,
        method: "GET",
      }),
    }),
      addLocation: builder.mutation<
          CommonResponseType & { data: any },
          { body: any }
        >({
          query: ({ body }) => ({
            url: END_POINTS.addLoaction,
            method: "POST",
            body,
          }),
        }),
    getLoactionId: builder.query<
      CommonResponseType & { data: any },
      {
        id: number;
      }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.locationById}${id}/`,
        method: "GET",
      }),
    }),
    updateLoaction: builder.mutation<CommonResponseType, { body: any; id: number }>(
      {
        query: ({ body, id }) => ({
          url: `${END_POINTS.updateLoaction}${id}/`,
          method: "PUT",
          body,
        }),
      }
    ),
   
    deleteLoaction: builder.mutation<CommonResponseType, { id: number }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteLoaction}${id}/`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useAddLocationMutation,
useDeleteLoactionMutation,
useLazyGetLoactionIdQuery,
useLazyGetLoactionQuery,
useUpdateLoactionMutation
} = GioLoactionApi;
